jQuery(document).ready(function ($) {
  // Slick carousel initialization
  const $carousel = $('.mb_colleagues-carousel .carousel-wrapper');
  const $popUp = $('.mb_colleague-popup');
  const $body = $('body');
  // Move all colleague popups to be direct children of <body>
  $popUp.each(function () {
    $(this).appendTo('body');
  });

  // Popup logic: show/hide only for active colleague
  $('.colleague-popup-trigger').on('click', function () {
    // Find the active slide
    const $activeSlide = $carousel.find('.slick-current.slick-active .carousel-slide');
    const colleagueId = $activeSlide.data('id');
    // Hide all popups first
    $popUp.hide();
    // Show the selected popup
    $('#mb_colleague-popup-' + colleagueId).fadeIn(200);
    // Lock body scroll
    $body.addClass('popup-open');
  });

  // Close logic
  $('.colleague-popup-close').on('click', function () {
    $(this).closest('.mb_colleague-popup').fadeOut(200);
    // Unlock body scroll
    $body.removeClass('popup-open');
  });

  // Off click close logic
  $popUp.on('click', function (e) {
    if (!$(e.target).closest('.popup-content').length) {
      $(this).fadeOut(200);
      // Unlock body scroll
      $body.removeClass('popup-open');
    }
  });
  // Prevent closing when clicking inside popup-content
  $('.mb_colleague-popup .popup-content').on('click', function (e) {
    e.stopPropagation();
  });
});
